import angular from "angular";

import DependencyListBuilder from "../../utility/DependencyListBuilder";

import CreateTrackingEventDialogManagerController from "./CreateTrackingEventDialogManager";

const CreateTrackingEventDialogComponent = {
    name: "tbCreateTrackingEventLauncher",
    config: {
        template: CreateTrackingEventDialogManagerController.template,
        bindings: {
        },
        controller: CreateTrackingEventDialogManagerController,
        controllerAs: CreateTrackingEventDialogManagerController.controllerAs
    }
};

const createTrackingEventDialogComponentDependencies = DependencyListBuilder([
    CreateTrackingEventDialogManagerController.dependencies
]);

export default angular
    .module(
        "trackerbase-app.components.create-tracking-event-dialog",
        createTrackingEventDialogComponentDependencies
    )
    .component(CreateTrackingEventDialogComponent.name, CreateTrackingEventDialogComponent.config)
    .name;



//////////////////
// WEBPACK FOOTER
// ./src/views/create-tracking-event-dialog/index.js
// module id = qKoZ
// module chunks = 1